import { Button } from '@finpay-development/shared-components';
import { Grid, Typography, Button as MUIButton, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { formatNumberToUSD } from 'src/shared/calculators';
import type { PaymentProgramViewContext } from './use-payment-program-view';

interface FullPaymentViewProps {
  ctx: PaymentProgramViewContext;
}

export function FullPaymentView({ ctx }: FullPaymentViewProps) {
  const {
    currentProgramType,
    pfrAmt,
    remainingPfr,
    matchingRule,
    handleBack,
    handleSelectFullPay,
    handleOtherPrograms,
  } = ctx;

  return (
    <Grid item xs={12}>
      <Grid container className="mt-4">
        <Typography variant="body2" textAlign="left" sx={{ mb: 5, fontSize: '2rem', lineHeight: '2.6rem' }}>
          Your first option is the <Box component="span" sx={{ fontWeight: 'bold' }}>Single Pay Program</Box> where
          you make a single payment today for the full estimated amount owed. This is a great option because it allows
          you to get it out of the way and focus on your health.{' '}
          <Box component="span" sx={{ fontWeight: 'bold' }}>Does this option work for you?</Box>
        </Typography>

        <Grid container direction="row" className="table-header">
          <Grid item xs={6} className="mt-2 pl-2">
            <Typography variant="subtitle2" textAlign="center">
              Total Estimate
            </Typography>
          </Grid>
          <Grid item xs={6} className="mt-2 pr-2">
            <Typography variant="subtitle2" textAlign="center">
              Balance
            </Typography>
          </Grid>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={6} className="mt-2 pl-2">
            <Typography variant="subtitle2" textAlign="center">
              {formatNumberToUSD(pfrAmt)}
            </Typography>
          </Grid>
          <Grid item xs={6} className="mt-2 pl-2">
            <Typography variant="subtitle2" textAlign="center">
              {formatNumberToUSD(remainingPfr)}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1} alignItems="center">
        {currentProgramType !== 'full' && (
          <Grid item xs={12} md={2} className="mt-2">
            <MUIButton
              onClick={handleBack}
              variant="outlined"
              fullWidth
              test-id="payment-program-full-back"
              sx={{
                backgroundColor: 'white',
                borderColor: '#e0e0e0',
                color: '#000',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                  borderColor: '#bdbdbd',
                },
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: '1rem', mr: 0.5 }} /> Back
            </MUIButton>
          </Grid>
        )}
        <Grid item xs={12} md={currentProgramType !== 'full' ? 5 : 6} className="mt-2">
          <Button onClick={handleSelectFullPay} fullWidth test-id="payment-program-full-add-payment">
            Add Payment Details
          </Button>
        </Grid>
        {matchingRule?.ruleId !== 0 && (
          <Grid item xs={12} md={currentProgramType !== 'full' ? 5 : 6} className="mt-2">
            <MUIButton
              onClick={handleOtherPrograms}
              fullWidth
              variant="text"
              sx={{ textTransform: 'none' }}
              test-id="payment-program-full-cant-afford"
            >
              Can't afford?
            </MUIButton>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
